























































import { Component, Vue, Ref } from "vue-property-decorator";
import UserListSvc from "@/services/UserList";
import { appModule } from "@/store/modules/app";
import { userModule } from "@/store/modules/user";

import DrawingCanvas from "@/components/drawing-canvas/DrawingCanvasBlank.vue";
@Component({
  components: {
    DrawingCanvas
  }
})
export default class TandatanganUploadCard extends Vue {
  @Ref("drawcanv") readonly drawcanv;

  ttdActiveImage = "";
  signatureFile = null;
  signatureUploading = false;
  ttdDrawedImage = "";
  activeUserId: number | string = "";

  mounted() {
    this.activeUserId = userModule.user?.id ?? "";

    this.loadActiveSignature();
  }

  async loadActiveSignature() {
    if (!this.activeUserId) return;

    const user = await UserListSvc.show(this.activeUserId).catch(() => null);
    const signatures = user?.signature ?? [];

    this.ttdActiveImage = signatures.length
      ? signatures[signatures.length - 1].image
      : "";
  }

  drawedImage(img) {
    this.ttdDrawedImage = img;
  }

  async updateSignature() {
    if (!this.activeUserId) {
      appModule.sendErrorAlert(
        "Sesi pengguna tidak terbaca. Silakan muat ulang halaman."
      );
      return;
    }

    if (!this.signatureFile && !this.ttdDrawedImage) {
      appModule.sendErrorAlert(
        "Pilih berkas tanda tangan atau bubuhkan tanda tangan pada kanvas terlebih dahulu."
      );
      return;
    }

    this.signatureUploading = true;

    let resp = { status: null };

    try {
      if (this.signatureFile) {
        resp = await UserListSvc.updateSignature(
          this.activeUserId,
          this.signatureFile
        );
      } else if (this.ttdDrawedImage) {
        resp = await UserListSvc.updateSignatureBase64(
          this.activeUserId,
          this.ttdDrawedImage
        );
      }
    } catch (err) {
      this.signatureUploading = false;
      return;
    }

    if (resp.status == 1) {
      appModule.NoticeDelay("Berhasil menambahkan tanda tangan!");

      await this.loadActiveSignature();

      this.signatureFile = null;
      this.ttdDrawedImage = "";
      this.drawcanv?.clearMode();
    }

    this.signatureUploading = false;
  }
}
